"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var textAligns = new Set(['left', 'center', 'right']);
exports.default = (function (_a) {
    var textAlign = _a.textAlign;
    return textAlign && textAligns.has(textAlign) && "text-align: " + textAlign + ";";
});
